import { Alert } from 'react-bootstrap';
import "../../sass/layout/unauthorizedAlert/unauthorizedAlert.css";

const UnauthorizedAlert = () => {
	return (
		<div className="unauthorized-alert-container">
			<div className="unauthorized-alert">
				<Alert variant="secondary">
					You do not have access to this page.
				</Alert>
			</div>
		</div>
	);
};

export default UnauthorizedAlert;